import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldListItem } from 'src/modules/sm-base/netgen/FrontendFieldListItem';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { Resource } from '../../netgen/Resource';
import { ResourceType } from '../../netgen/ResourceType';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-edit-resource',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditResourceComponent extends AdminBaseEditComponent<Resource> {

    service = inject(ProjectPlanningService);

    definition = ProjectPlanningTools.definitionResource;

    resourceTypes: ResourceType[];
    
    getForm(): FrontendForm {
        return this.app.tForm("entity.Resource.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { 
                mandatory: true
            }),
            new FrontendField("mail", "", FrontendFieldType.string),
            new FrontendField("color", "", FrontendFieldType.color, { predefinedColors: Utils.getMaterialColors()}),                  
            new FrontendField("typeId", "", FrontendFieldType.dropdown, { 
                mandatory: true, 
                listItems: FrontendFieldListItem.make(this.resourceTypes, item => [item.id, item.title]),
                dropdownCanFilter: true
            })                             
        ]));
    }
    
    async initAdditionalData(): Promise<void> {
        this.resourceTypes = await this.service.getResourceTypes();
    }
    
    
}
